import { render, staticRenderFns } from "./ModalEditSportDataCompetition.vue?vue&type=template&id=13227ea1&"
import script from "./ModalEditSportDataCompetition.vue?vue&type=script&lang=js&"
export * from "./ModalEditSportDataCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports